import { Text } from '@shopify/polaris';
import { formatToCurrency } from '../../../../shared/components/functions.jsx';

const deltaColor = (val) => (val > 0.005 ? '#27ae60' : val < -0.005 ? '#e74c3c' : '#666');
const deltaPrefix = (val) => (val > 0.005 ? '+' : '');

function DiffRow({ label, valA, valB, delta, format = 'currency', bold }) {
  const weight = bold ? 'bold' : 'regular';
  const fmt = (v) => (format === 'percent' ? `${v.toFixed(1)}%` : formatToCurrency(v));
  const deltaFmt = format === 'percent' ? `${deltaPrefix(delta)}${delta.toFixed(1)} pp` : `${deltaPrefix(delta)}${formatToCurrency(delta)}`;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px 110px', gap: '8px', padding: '4px 0', alignItems: 'center' }}>
      <Text variant="bodySm" as="span" fontWeight={weight}>
        {label}
      </Text>
      <Text variant="bodySm" as="span" fontWeight={weight} alignment="end">
        {fmt(valA)}
      </Text>
      <Text variant="bodySm" as="span" fontWeight={weight} alignment="end">
        {fmt(valB)}
      </Text>
      <Text variant="bodySm" as="span" fontWeight="semibold" alignment="end">
        <span style={{ color: deltaColor(delta) }}>{deltaFmt}</span>
      </Text>
    </div>
  );
}

export default function DiffSummaryCard({ summary, versionA, versionB }) {
  if (!summary) return null;

  return (
    <div>
      {/* Column headers */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px 110px', gap: '8px', borderBottom: '1px solid #e1e3e5', paddingBottom: '4px', marginBottom: '4px' }}>
        <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold">
          Metric
        </Text>
        <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold" alignment="end">
          v{versionA}
        </Text>
        <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold" alignment="end">
          v{versionB}
        </Text>
        <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold" alignment="end">
          Delta
        </Text>
      </div>

      <DiffRow label="Total Selling" valA={summary.sellingA} valB={summary.sellingB} delta={summary.sellingDelta} bold />
      <DiffRow label="Total Cost" valA={summary.costA} valB={summary.costB} delta={summary.costDelta} />
      <DiffRow label="Margin" valA={summary.marginA} valB={summary.marginB} delta={summary.marginDelta} />
      <DiffRow label="Margin %" valA={summary.marginPctA} valB={summary.marginPctB} delta={summary.marginPctB - summary.marginPctA} format="percent" />
    </div>
  );
}
